import IconResizer from "../icon/IconResizer"
import CheckIcon from "../icon/CheckIcon"

interface ParentControlledCheckBoxProps {
    children: string
    value: boolean
    onChange: (val: boolean) => void
}

function ParentControlledCheckBox(props: ParentControlledCheckBoxProps) {
    const size = 20

    return (
        <div className={"w-full flex items-center space-x-4"}>
            <div
                onClick={() => props.onChange(!props.value)}
                className={
                    "border border-neutral-200 rounded flex items-center justify-center hover:bg-neutral-100 cursor-pointer hover:border-blue-600"
                }
                style={{
                    width: size,
                    minWidth: size,
                    height: size,
                    minHeight: size
                }}>
                <div
                    style={{
                        marginLeft: -10,
                        marginTop: -10
                    }}>
                    {props.value && (
                        <IconResizer size={10} color={"text-neutral-500"}>
                            <CheckIcon />
                        </IconResizer>
                    )}
                </div>
            </div>
            <div>{props.children}</div>
        </div>
    )
}

export default ParentControlledCheckBox
